// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';
import _ from 'lodash';

import { DashComponent, DashboardLauncher, DashboardReload } from 'wdna-components/lib/dashboards';
import { messageError } from 'wdna-components/lib/helpers/notification';
import { initProcess, finishProcess } from 'wdna-components/lib/scheduler/actions';

/* Types */
import { FilterContext } from '../../../../types';

/* Sidebar */
import Filter from './dashboard/Filter';

/* Components */
const Container: React.LazyExoticComponent<any> = React.lazy(() => import('./dashboard/Container'));

const DEFAULT_DASHBOARD_TIMEOUT: number = 24000000;
const dashConfig: DashComponent[] = [
  {
    component: Container,
    props: {
      title: '',
      className: 'reading-container',
    },
  },
];

interface Props {
  rowId: number | undefined;
}

interface State {
  sidebar?: React.ReactNode[];
}

class MainDashboard extends React.Component<Props, State> {
  private pid: string;

  public constructor(props: Props) {
    super(props);

    this.pid = window.getStr();
    this.state = {
      sidebar: undefined,
    };
  }

  public componentDidMount(): void {
    this.fetchData();
  }

  public componentDidUpdate(prevProps: Props): void {
    if (this.props !== prevProps) {
      this.fetchData();
    }
  }

  public updateParent = (data: State, cb?: (() => void)): void => {
    this.setState({ ...data, }, () => {
      if (typeof cb === 'function') cb();
    });
  };

  public fetchData = (): void => {
    window.store.dispatch(initProcess(this.pid));
    try {
      this.processSidebarConfig();
    } catch (error: any) {
      messageError('Error', error.message);
    }

    setTimeout(() => {
      window.store.dispatch(finishProcess(this.pid));
    }, 1000);
  };

  public processSidebarConfig = (): void => {
    const sidebar: React.ReactNode[] = [(): JSX.Element => <Filter rowId={this.props.rowId} />];

    this.setState({
      sidebar,
    });
  };

  public render(): React.ReactNode {
    const { sidebar } = this.state;
    if (!dashConfig || !sidebar) return null;
    return (
      <FilterContext.Provider value={{ parentState: this.state, updateParent: this.updateParent }}>
        <DashboardLauncher config={dashConfig} sidebar={sidebar} hiddenSidebar />
      </FilterContext.Provider>
    );
  }
}

const View: React.MemoExoticComponent<any> = React.memo((props: Props) => {
  return (
    <DashboardReload timeOut={DEFAULT_DASHBOARD_TIMEOUT}>
      <MainDashboard {...props} />
    </DashboardReload>
  );
});

export default View;
